import React from 'react';

const AccountTitle = ({ record }) => {
	return <span>Account {record ? `"${record.fullName}"` : ''}</span>;
};

export default AccountTitle
